export default "__VITE_ASSET__3KwL9ka6__"